import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatFormField, MatHint } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatSlideToggle,MatSlideToggleChange } from '@angular/material/slide-toggle';
import { QuillModule, QuillModules } from 'ngx-quill';
import { Subscription } from 'rxjs';

import { CommonService } from '@shared/services/common.service';
import { MetadataService, MetadataSlugs } from '@shared/services/metadata.service';

@Component({
    selector: 'app-login-popup',
    templateUrl: './login-popup.component.html',
    styleUrls: ['./login-popup.component.scss'],
    standalone: true,
    imports: [MatSlideToggle, MatFormField, MatInput, ReactiveFormsModule, FormsModule, MatHint, QuillModule, MatButton]
})
export class LoginPopupComponent implements OnInit, OnDestroy {
  protected htmlContent: string | null = null;
  protected popupTitle: string | null = null;
  protected isPopupEnabled = false;
  private _subs: Subscription[] = [];
  protected quillModules: QuillModules = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],
      ['blockquote', 'code-block'],
      [{ header: 1 }, { header: 2 }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ indent: '-1' }, { indent: '+1' }],
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ['link'],
      ['clean']
    ]
  };

  constructor(
    private _metadataService: MetadataService,
    private _commonService: CommonService
  ) {}

  ngOnInit(): void {
    this.getContent();
    this.getTitle();
    this.getPopupEnabled();
  }

  getContent() {
    this._subs.push(
      this._metadataService.get<string>(MetadataSlugs.LoginPopupContent).subscribe({
        next: metadata => {
          if (metadata.value) {
            this.htmlContent = metadata.value;
          } else {
            this.htmlContent = '<p>Welcome! Please read this important message.</p>';
          }
        },
        error: () => {
          this.htmlContent = '<p>Welcome! Please read this important message.</p>';
        },
      })
    );
  }

  getTitle() {
    this._subs.push(
      this._metadataService.get<string>(MetadataSlugs.LoginPopupTitle).subscribe({
        next: metadata => {
          if (metadata.value) {
            this.popupTitle = metadata.value;
          } else {
            this.popupTitle = 'Important Message';
          }
        },
        error: () => {
          this.popupTitle = 'Important Message';
        },
      })
    );
  }

  getPopupEnabled() {
    this._subs.push(
      this._metadataService.get<string>(MetadataSlugs.LoginPopupEnabled).subscribe({
        next: metadata => {
          this.isPopupEnabled = metadata.value ? metadata.value === 'true' : false;
        },
        error: () => {
          this.isPopupEnabled = false;
        },
      })
    );
  }

  onPopupEnabledChange(event: MatSlideToggleChange) {
    this._subs.push(
      this._metadataService
        .set(MetadataSlugs.LoginPopupEnabled, event.checked.toString())
        .subscribe({
          next: () => {
            this._commonService.openSuccessSnackBar('Login popup setting updated!');
          },
          error: () => {
            this._commonService.openErrorSnackBar('Error updating login popup setting');
          },
        })
    );
  }

  save() {
    // Save title
    this._subs.push(
      this._metadataService.set(MetadataSlugs.LoginPopupTitle, this.popupTitle).subscribe({
        next: () => {
          // Save content after title is saved
          this._subs.push(
            this._metadataService.set(MetadataSlugs.LoginPopupContent, this.htmlContent).subscribe({
              next: () => {
                this._commonService.openSuccessSnackBar('Successfully saved!');
              },
              error: () => {
                this._commonService.openErrorSnackBar('Error occurred');
              },
            })
          );
        },
        error: () => {
          this._commonService.openErrorSnackBar('Error occurred');
        },
      })
    );
  }

  ngOnDestroy(): void {
    this._subs.forEach(sub => sub.unsubscribe());
  }
}
